import DocumentsUploadedViewModel from "../components/documentsUploadedViewModel";
import { Router } from "@frui.ts/screens";

export const RefundRequestDocumentsUploadedViewModelNavigationName = "refund_request_documents";

@Router.registerRoute({
  route: RefundRequestDocumentsUploadedViewModelNavigationName,
  name: "refund_request_documents",
})
export default class RefundRequestDocumentsUploadedViewModel extends DocumentsUploadedViewModel {}
